<template>
  <div class="fts-label-group">
    <!-- icon -->
    <fts-moji
      :emoji="getIcon"
      :size="emojiSize"
      :class="getIconClass"
      v-if="emoji && getIcon"
    />
    <i 
      :class="[
        getIcon,
        getIconClass,
        {'label-group__icon--system': isSystemDefault }
      ]"
      v-else-if="getIcon"
    />
    <!-- label -->
    <div :class="getLabelClass">{{getLabel}}</div>
  </div>
</template>

<script>
import commons from '../../commons/commons';
import FTSMoji from "../FTSMoji";

export default {
  components: {
    "fts-moji": FTSMoji,
  },
  props: {
    /* data */
    itemId: [String, Number],
    item: Object,
    list: Array,
    listKey: {
      type: String,
      default: "id",
    },
    /* icon */
    icon: String,
    iconKey: String,
    /* icon:emoji */
    emoji: Boolean,
    emojiSize: {
      type: Number,
      default: 16,
    },
    /* icon:fts-font */
    systemDefault: Boolean,
    systemDefaultKey: {
      type: String,
      default: "system",
    },
    /* label */
    label: String,
    labelKey: {
      type: String,
      default: "name",
    },
    /* class */
    iconClass: String,
    appendIconClass: String,
    labelClass: String,
    appendLabelClass: String,
  },
  computed: {
    getItem() {
      if (this.itemId && Array.isArray(this.list)) {
        const res = this.list.find(x => x && x[this.listKey] == this.itemId);
        return res;
      } else if (Object.prototype.toString.call(this.item) === '[object Object]') {
        return this.item;
      }
    },
    getIcon() {
      function iconKey(vm) {
        if (vm.iconKey) return vm.iconKey;
        else if (vm.emoji) return 'emoji';
        return 'icon'
      }

      if (this.icon) return this.icon;

      const icon = this.getItem && this.getItem[iconKey(this)];
      return this.emoji ? icon : commons.informationIcon(icon);
    },
    getLabel() {
      if (this.label) return this.label;
      return this.getItem && this.getItem[this.labelKey] || '(undefined)';
    },
    isSystemDefault() {
      return this.systemDefault ? this.systemDefault : this.getItem && this.getItem[this.systemDefaultKey];
    },
    getIconClass() {
      function defaultClass(vm) {
        if (vm.emoji) return 'label-group__emoji';
        return 'label-group__icon'
      }

      if (this.iconClass) return this.iconClass;
      return this.appendIconClass ? `${defaultClass(this)} ${this.appendIconClass}` : defaultClass(this);
    },
    getLabelClass() {
      if (this.labelClass) return this.labelClass;
      return this.appendLabelClass ? `label-group__label ${this.appendLabelClass}`: 'label-group__label';
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";
.fts-label-group {
  min-width: 0;
  display: flex;
  align-items: center;
  .label-group__emoji {
    margin-right: .375rem;
  }
  .label-group__icon {
    margin-right: .375rem;
    color: $secondaryColor;
    &.label-group__icon--system {
      color: $primaryColor;
    }
  }
  .label-group__label {
    @include text-overflow-ellipsis;
  }
}
</style>